import { useContext } from 'react';
import Upload from 'src/components/Attachments/Upload';
import Section from 'src/components/util/Section';
import Subheader from 'src/components/util/Subheader';
import FormContext from 'src/contexts/settlement-context';
import { attachments } from 'src/data/Attachments/constant';
import { Button } from '@mui/material';

export default function Attachments() {
  const { formData } = useContext(FormContext);

  return (
    <Section title="Attachments">
      <Subheader>Include the following:</Subheader>
      {attachments.map((attachment, index) => (
        <div className="flex flex-col gap-1" key={index}>
          {attachment.title} <i>Max 2 files (4MB each)</i>
          <Upload file={formData[attachment.name]} title={attachment.name} />
        </div>
      ))}
      <p>
        Download your most recent valuation/tax notice by using the link below.{' '}
        <span className="font-semibold">
          After downloading your file, please return to this page to complete your upload.
        </span>
      </p>

      <div className="flex-start">
        <Button
          href="https://www.utahcounty.gov/Dept/Treas/DuplicateNotices.asp"
          target="_blank"
          variant="contained"
        >
          Request Download
        </Button>
      </div>
    </Section>
  );
}
